import { UseFormWatch } from 'react-hook-form';
import { EditableQuestion, QuestionType } from '../../../../../types';

export const useShouldShowAnswersEditor = (watch: UseFormWatch<EditableQuestion>) => {
  const questionType = watch('type');

  return questionType !== QuestionType.FREE_TEXT && questionType !== QuestionType.IMAGE_UPLOAD;
};
